module.exports = __webpack_public_path__ + "static/media/kitchen.1f904690.svg";